import {
    green50,
    green200,
    green400,
    green700,
    grey900,
} from "material-ui/styles/colors";

var GreenTheme = {
    fontFamily: "arial",
    palette : {
        primary1color:      green700,
        primary2color:      green400,
        primary3color:      green200,
        accent1color:       "#E73677",
        accent2color:       "#D0FFCA",
        accent3color:       "#FF9797",
        textColor:          grey900,
        canvasColor:        green50,
        alternateTextColor: green200, // Button background color.
    }
};

export default GreenTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/GreenTheme.js
 **/